// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__38HNk","label":"LabeledBox_label__3EJJy"};